import { ADD_PRODUCT, RESET_STATE } from "./productActionsTypes";

const initialState = {
  product: null
};

function normalizeProduct(product) {
  // 1) Цена
  const price =
    typeof product.price === "object" && product.price.data !== undefined
      ? Number(product.price.data)
      : product.price;

  // 2) Галерея
  const images = Array.isArray(product.images) ? product.images : [];

  // 3) Атрибуты
  const attributes = product.attributes
    ? product.attributes
    : Object.fromEntries(
        (product.characteristic_list?.list || []).map(({ name, value }) => [
          name,
          value
        ])
      );

  return {
    ...product,
    price,
    images,
    attributes
  };
}

export default function productReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_PRODUCT:
      return {
        ...state,
        product: normalizeProduct(action.payload)
      };
    case RESET_STATE:
      return initialState;
    default:
      return state;
  }
}
